import debugLogScriptName from '@/debug-log-script-name'
import _ from 'lodash'

$(function() {
  const $pwStrength = $('.pw-strength')
  debugLogScriptName($pwStrength, 'password-strenght.js')
  $pwStrength.each(function() {
    var $el = $(this),
      $form = $el.parents('form'),
      $submit = $form.find('[type="submit"]'),
      $text = $el.find('.pw-strength__feedback-text'),
      $password = $($el.attr('data-password')),
      $confirm = $($el.attr('data-confirm')),
      $domain = $form.find('[name="domain"]'),
      $username = $form.find('[name="email"]'),
      $confirmFormGroup = $confirm.parents('.form-group'),
      texts = [
        'Weak password',
        'Weak password',
        'Not strong enough',
        'Strong password',
        'Strong password',
      ],
      result,
      score,
      nomatch = false,
      url = $el.attr('data-strength')

    var maybeEnableSubmitButton = function() {
      var confirmVal = $confirm.val(),
        passwordVal = $password.val(),
        domainVal = $domain.val(),
        usernameVal = $username.val()

      if (
        score > 2 &&
        !nomatch &&
        passwordVal !== '' &&
        confirmVal !== '' &&
        domainVal !== '' &&
        usernameVal !== ''
      ) {
        $submit.prop('disabled', false)
      } else {
        $submit.prop('disabled', true)
      }
    }

    function removeScoreClass() {
      $el.removeClass(function(i, className) {
        return (className.match(/(^|\s)pw-strength--score-\S+/g) || []).join(
          ' ',
        )
      })
    }

    $domain.add($username).on(
      'keyup',
      _.debounce(function(e) {
        maybeEnableSubmitButton()
      }, 250),
    )

    $password.add($confirm).on(
      'keyup',
      _.debounce(function(e) {
        var confirmVal = $confirm.val(),
          passwordVal = $password.val()

        if (passwordVal !== '' && confirmVal !== '') {
          if (passwordVal !== confirmVal) {
            $text.text('No match!')
            $el.addClass('pw-strength--score-nomatch')
            $confirmFormGroup.addClass('form-group--has-error')
            nomatch = true
          } else {
            $.ajax({
              method: 'POST',
              url: url,
              data: { password: passwordVal },
              dataType: 'json',
            }).done(function(data) {
              score = parseInt(data.score, 10)
              $text.text(texts[score])
              $el.removeClass('pw-strength--score-nomatch')
              removeScoreClass()
              $el.addClass('pw-strength--score-' + score)
              $confirmFormGroup.removeClass('form-group--has-error')
              nomatch = false
              maybeEnableSubmitButton()
            })
          }
        }

        if ($(e.target).is($password) && !nomatch) {
          removeScoreClass()

          if (passwordVal !== '') {
            $.ajax({
              method: 'POST',
              url: url,
              data: { password: passwordVal },
              dataType: 'json',
            }).done(function(data) {
              score = parseInt(data.score, 10)
              $text.text(texts[score])
              $el.addClass('pw-strength--score-' + score)
            })
          } else if (passwordVal == '') {
            $text.text('Enter password')
          }
        }

        maybeEnableSubmitButton()
      }, 250),
    )
  })
})
